import React, { Component } from 'react';
// import Iframe from './Iframe';
import { getEnvelopeDetails } from './helpers/fireHelper';
import { withRouter } from 'react-router-dom';
import { valuesToHtmlString } from './helpers/iframeHelpers';

class Host extends Component {
  constructor(props) {
    super(props)
    this.state = { envelope: null }
  }
  componentDidMount() {
    // FIX PRIVATE ENVELOPES
    getEnvelopeDetails(this.props.match.params.key)
      .then(envelope => {
        if (typeof envelope.isHosted !== "undefined" && envelope.isHosted) {
          this.setState({ envelope });
          var ifr = this.refs.iframe;
          // console.log('WINDOW:', window)
          // console.log(window.outerWidth);
          // console.log(window.offsetWidth);
          // console.log(screen.width);


          // console.log('WIDTH', window.innerWidth)
          ifr.style.width = window.innerWidth + "px";
          ifr.style.height = (window.innerHeight - 10) + "px";

          var doc = this.refs.iframe.contentDocument;
          doc.open();
          doc.write(valuesToHtmlString(this.state.envelope));
          doc.close();
        }
      })
  }
  render() {
    // if (this.state.envelope) {
    //   console.log(valuesToHtmlString(this.state.envelope));
    // }

    return (
      <div>
      <iframe className="hosted-iframe" ref="iframe"></iframe>
    {/* { this.state.envelope ? <Iframe size="host" env={this.state.envelope}/> : "LOADING..."}  */}
      </div>
    )
  }
}
export default withRouter(Host);



// WEBPACK FOOTER //
// ./src/Host.js